import { controls,grouped } from "../controls";
const product_tags = {
label: "Product Tags",
pageLabel: "Product Tags",starting: true,url: "autogen",
formActions: { edit: { allow: true },delete:{allow:true} },
pageType: "history",
filter:[
...controls.displayText({ tab: "filter", label: "Product Id"}),
...controls.numberOnly({ tab: "filter",  placeHolder: "", name: "product_id",maxlength:200}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Tag Id"}),
...controls.numberOnly({ tab: "filter",  placeHolder: "", name: "tag_id",maxlength:200}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
]
,form:[
...controls.displayText({ tab: "general", label: "Product",star:true}),
...controls.oc({ tab: "general", c: "Product", placeHolder: "Product Code", name: "product_code", isRequired:true,fastpath:"products"}),
...controls.showData({ tab: "general", displaytype: "capital", data: "product_display"}),
...controls.displayText({ tab: "general", label: "Tag",star:false}),
...controls.oc({ tab: "general", c: "Tag", placeHolder: "Tag Code", name: "tag_code", isRequired:false,fastpath:"tags"}),
...controls.showData({ tab: "general", displaytype: "capital", data: "tag_display"}),
]
,history:{
perPage: 10,
reportHeader: "Product Tags",
pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
clickable: true,
displayColumns: [
{Header: "Sr",type: "autoinc",accessor: "srno",align: "center",width: 30},
{Header: "Product Id",accessor: "product_id",},
{Header: "Tag Id",accessor: "tag_id",},
]}};
export default product_tags;